import React from "react";
export enum LocalStorage {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  USER = "user",
  ROLE_NAME = "roleName",
  COLORS = "colors",
  COMPANY_ID = "companyId",
  PROFILE = "profile",
  PERMISSIONS = "permissions",
  ROLE_ID = "roleId",
}
